import { CaixasSupplierSummaryCard } from "@/components/caixas/CaixasSupplierSummaryCard";
import type { CaixaSupplierSummary } from "@/features/caixas/types";

interface CaixasSupplierSummaryListProps {
  suppliers: CaixaSupplierSummary[];
  selectedSupplierId?: string | null;
  isLoading?: boolean;
  error?: string;
  onOpenHistory: (supplier: CaixaSupplierSummary) => void;
}

export function CaixasSupplierSummaryList({
  suppliers,
  selectedSupplierId,
  isLoading = false,
  error,
  onOpenHistory,
}: CaixasSupplierSummaryListProps) {
  if (isLoading) {
    return (
      <section className="caixas-supplier-list-state">
        Carregando fornecedores...
      </section>
    );
  }

  if (error) {
    return (
      <section className="caixas-supplier-list-state" role="alert">
        {error}
      </section>
    );
  }

  if (suppliers.length === 0) {
    return (
      <section className="caixas-supplier-list-state">
        Nenhum fornecedor encontrado
      </section>
    );
  }

  return (
    <section className="caixas-supplier-list">
      {suppliers.map((supplier) => (
        <CaixasSupplierSummaryCard
          key={supplier.id}
          supplier={supplier}
          isSelected={supplier.id === selectedSupplierId}
          onOpenHistory={onOpenHistory}
        />
      ))}
    </section>
  );
}
